import { Col, Form, InputNumber, Row, Table } from 'antd';
import { useEffect } from 'react';
import MoneyDisplay from '../../Common/MoneyDisplay';
import TaxRateSelect from '../../Common/TaxRateSelect';


const OverallProjectExpenses = ({
  budgetPlanData,
  setBudgetPlanData,
  totals,
  readOnly = false
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (budgetPlanData) {
      form.setFieldsValue(budgetPlanData);
    }
  }, [budgetPlanData, form]);

  const handleValuesChange = (_, allValues) => {
    setBudgetPlanData(prev => ({
      ...prev,
      ...allValues,
    }));
  };

  return (
    <Form
      layout="vertical"
      size="small"
      form={form}
      initialValues={budgetPlanData}
      onValuesChange={handleValuesChange}
      disabled={readOnly}
    >
      <Row gutter={12}>
        {/* LEFT: editable business inputs */}
        <Col span={14}>
          <Row gutter={8}>
            <Col span={8}>
              <Form.Item
                name="production_fee_percent_full"
                label="Provizija % (polna)"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <InputNumber size="small" min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="production_fee_percent_discounted"
                label="Provizija % (znižana)"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <InputNumber size="small" min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="production_fee_amount"
                label="Znesek provizije"
              >
                <MoneyDisplay type={null} val={totals?.production_fee_amount || 0} />
              </Form.Item>
            </Col>

          </Row>

          <Row gutter={8}>

            <Col span={8}>
              <Form.Item
                name="not_forseen_percent_full"
                label="Nepredvideno % (polno)"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <InputNumber size="small" min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="not_forseen_percent_discounted"
                label="Nepredvideno % (znižano)"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <InputNumber size="small" min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="not_forseen_amount"
                label="Znesek nepredvidenega"
              >
                <MoneyDisplay type={null} val={totals?.not_forseen_amount || 0} />
              </Form.Item>
            </Col>

            </Row>
            <Row gutter={8}>

            <Col span={12}>
              <Form.Item
                name="discount_percent"
                label="Popust na skupno (%)"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <InputNumber size="small" min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="tax_rate"
                label="Davčna stopnja"
                rules={[{ required: true, message: 'Obvezno' }]}
              >
                <TaxRateSelect size="small" />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        {/* RIGHT: calculated / display-only values */}
        <Col span={10}>
          <Table
            size="small"
            pagination={false}
            showHeader={false}
            rowKey="key"
            columns={[
              {
                dataIndex: 'label',
                width: '60%',
              },
              {
                dataIndex: 'value',
                align: 'right',
                render: val => <MoneyDisplay type={null} val={val} />,
              },
            ]}
            dataSource={[
              {
                key: 'full_budget',
                label: 'Polni proračun',
                value: totals?.full_budget || 0,
              },
              {
                key: 'discount',
                label: 'Znesek popusta',
                value: totals?.full_budget_discount_amount || 0,
              },
              {
                key: 'price',
                label: 'Cena',
                value: totals?.price || 0,
              },
              {
                key: 'total_price',
                label: 'Skupna cena',
                value: totals?.total_price || 0,
              },
              {
                key: 'tax',
                label: 'Znesek davka',
                value: totals?.tax_amount || 0,
              },
              {
                key: 'grand_total',
                label: 'Končni znesek',
                value: totals?.grand_total || 0,
              },
            ]}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default OverallProjectExpenses;
